// services/addressServices.js
import { API_END_POINTS } from "../../API_END_POINTS";
import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_URL;

const addAddressUrl = `${API_BASE_URL}${API_END_POINTS.addAddress}`;
const showAddressUrl = `${API_BASE_URL}${API_END_POINTS.showAddress}`;
const editAddressUrl = `${API_BASE_URL}${API_END_POINTS.editAddress}`;
const deleteAddressUrl = `${API_BASE_URL}${API_END_POINTS.deleteAddress}`;

// Function to add a new address
export const addAddressService = async (addressData) => {
  try {
    const response = await axios.post(addAddressUrl, addressData, {
      headers: {
        "Content-Type": "application/json",
        authorization: `Bearer ${localStorage.getItem("authToken")}`,
      },
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || "Something went wrong!";
  }
};

// Function to fetch all addresses
export const showAddressService = async () => {
  try {
    const response = await axios.get(showAddressUrl, {
      headers: {
        "Content-Type": "application/json",
        authorization: `Bearer ${localStorage.getItem("authToken")}`,
      },
    });
    return response.data.data;
  } catch (error) {
    throw error.response?.data || "Something went wrong!";
  }
};

// Function to edit an existing address
export const editAddressService = async (updatedData) => {
  try {
    const response = await axios.patch(editAddressUrl, updatedData, {
      headers: {
        "Content-Type": "application/json",
        authorization: `Bearer ${localStorage.getItem("authToken")}`,
      },
    });
    console.log("response.data: ", response);
  } catch (error) {
    throw error.response?.data || "Something went wrong!";
  }
};

// Function to delete an existing address
export const deleteAddressService = async (id) => {
  try {
    const response = await axios.delete(`${deleteAddressUrl}/${id}`, {
      headers: {
        "Content-Type": "application/json",
        authorization: `Bearer ${localStorage.getItem("authToken")}`,
      },
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || "Something went wrong!";
  }
};
